var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWatches = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Accessories-Watch--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Accessories Watch Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.74 4h-9a0.49 0.49 0 0 0 -0.38 0.18C3.24 6.71 1.74 8.76 1.74 12s1.17 5.12 3.63 7.84a0.51 0.51 0 0 0 0.37 0.16h9a0.51 0.51 0 0 0 0.37 -0.16c2.46 -2.72 3.63 -4.58 3.63 -7.84s-1.5 -5.29 -3.62 -7.82a0.49 0.49 0 0 0 -0.38 -0.18Zm1 8a5.5 5.5 0 1 1 -5.5 -5.5 5.51 5.51 0 0 1 5.5 5.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.76 10.5h-1.27a0.24 0.24 0 0 0 -0.25 0.25l0 2.5a0.25 0.25 0 0 0 0.25 0.25h1.25a0.5 0.5 0 0 0 0.5 -0.5v-2a0.5 0.5 0 0 0 -0.48 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74 21.5h9s0.5 0 0.5 0.5v1.5s0 0.5 -0.5 0.5h-9s-0.5 0 -0.5 -0.5V22s0 -0.5 0.5 -0.5",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74 0h9s0.5 0 0.5 0.5V2s0 0.5 -0.5 0.5h-9s-0.5 0 -0.5 -0.5V0.5s0 -0.5 0.5 -0.5",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.79 10.61 -1.21 0.6L9.07 9a1 1 0 0 0 -1.66 1.1l2 3a1 1 0 0 0 0.83 0.45 0.93 0.93 0 0 0 0.45 -0.11l2 -1a1 1 0 0 0 -0.9 -1.78Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWatches);
export default ForwardRef;